var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescargarGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9793 4.5712C14.7027 4.51244 14.477 4.32865 14.3609 4.06527C13.0676 1.15724 10.075 -0.468889 7.08164 0.119552C4.35508 0.652983 2.21758 2.97507 1.76172 5.89936C1.62656 6.76243 1.63672 7.62676 1.78906 8.46858C1.83906 8.74321 1.72813 9.0491 1.50078 9.26956C0.546484 10.1951 0 11.5137 0 12.8881C0 15.5836 2.05586 17.7778 4.5832 17.7778H13.75C17.1965 17.7778 20 14.7868 20 11.1099C20 7.94056 17.8883 5.19048 14.9785 4.57162L14.9793 4.57078V4.5712ZM12.602 11.2945L10.3461 13.7012C10.0234 14.0454 9.59961 14.2188 9.17539 14.2205L9.16797 14.2221L9.16055 14.2205C8.73633 14.2188 8.31211 14.0454 7.98984 13.7012L5.73398 11.2945C5.4082 10.9469 5.4082 10.3852 5.73398 10.0372C6.05977 9.68922 6.58633 9.68963 6.9125 10.0372L8.33516 11.555V7.10958C8.33516 6.61782 8.70859 6.22067 9.16836 6.22067C9.62813 6.22067 10.0016 6.61824 10.0016 7.10958V11.555L11.4242 10.0372C11.75 9.68963 12.2766 9.68963 12.6027 10.0372C12.9289 10.3848 12.9285 10.9465 12.6027 11.2945H12.602Z",
    fill: "#62C776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescargarGreen);
export default __webpack_public_path__ + "static/media/descargarGreen.253c278b8ebc8041ef7a51148c6c48bb.svg";
export { ForwardRef as ReactComponent };